// src/components/mantenciones/MantencionRing.jsx
import React from 'react';
import { theme } from 'antd';
import { successColor, errorColor } from 'assets/theme/colors';

const { useToken } = theme;

// Donut de progreso por categoría. alert (rojo) > completo (verde) > en curso
// (color primario del tenant). El track usa un fill neutro del tema.
function MantencionRing({ done, total, alert = false }) {
  const { token } = useToken();
  const r = 14;
  const c = 2 * Math.PI * r;
  const pct = total ? done / total : 0;
  const col = alert ? errorColor : done === total && total > 0 ? successColor : token.colorPrimary;

  return (
    <div style={{ position: 'relative', width: 34, height: 34, flex: '0 0 auto' }}>
      <svg width="34" height="34" style={{ transform: 'rotate(-90deg)', display: 'block' }}>
        <circle
          cx="17"
          cy="17"
          r={r}
          stroke={token.colorFillSecondary}
          strokeWidth="3.5"
          fill="none"
        />
        <circle
          cx="17"
          cy="17"
          r={r}
          stroke={col}
          strokeWidth="3.5"
          fill="none"
          strokeLinecap="round"
          strokeDasharray={c}
          strokeDashoffset={c * (1 - pct)}
          style={{ transition: 'stroke-dashoffset .4s ease' }}
        />
      </svg>
      <span
        className="mono"
        style={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 10,
          fontWeight: 600,
          color: token.colorTextSecondary,
        }}
      >
        {done}
        <span style={{ opacity: 0.5 }}>/{total}</span>
      </span>
    </div>
  );
}

export default MantencionRing;
